const CLIENT_ID_KEY = 'client_id'
const RETURN_URL_KEY = 'redirect_uri'

export const buildLoginPageURL = ({ clientId, returnURL, loginLocation }) => {
  const queryParams = {
    [CLIENT_ID_KEY]: clientId,
    [RETURN_URL_KEY]: returnURL
  }

  const searchParams = new URLSearchParams(queryParams)
  const querystring = searchParams.toString()

  return `${loginLocation}?${querystring}/`
}

export const login = ({ loginLocation, clientId, returnURL }) => {
  window.location.href = buildLoginPageURL({
    clientId,
    returnURL,
    loginLocation
  })
}
